const OPTIN_ONETRUST_TRACKING_GROUP = 'C0004:1';

export const hasUserOptedInToTrackingConsent = () => {
  const userConsent = window.extractUserConsent();
  const userConsentList = userConsent?.groups?.split(',') || [];
  return userConsentList.includes(OPTIN_ONETRUST_TRACKING_GROUP);
};
